import React, { useState, useEffect } from 'react';
import BreakCrumbs from '../../components/BreakCrumbs';
import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import TableLoading from '../../components/TableLoading';
import { alertError } from '../../Util/Util';
import TableEmpty from '../../components/TableEmpty';
import { map, trim } from 'lodash';
import { useHistory } from 'react-router-dom';
import { LIST_PAGE_COUNT, PayingMemberPlanStatusText } from '../../data/common';
import PayingMemberPlanTable from '../../components/Member/PayingMemberPlanTable';
import memberAPI from '../../middleware/memberAPI';
import storeAPI from '../../middleware/storeAPI';

const PayingMemberPlanList = (props) => {
  const { match } = props;
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [plans, setPlans] = useState();
  const [planTotal, setPlanTotal] = useState();
  const [page, setPage] = useState(1);
  const [stores, setStores] = useState([]);
  const [search, setSearch] = useState({
    storeId: '',
    status: '',
  });

  useEffect(() => {
    storeAPI.getAllStores().then(
      (res) => {
        setStores(res || []);
      },
      (error) => {
        alertError(error);
      },
    );
  }, []);

  useEffect(() => {
    handleSearch();
  }, [page]);

  const handleChangeSearch = (e) => {
    const changeItem = e.target.name;
    const changeValue = e.target.value;

    setSearch({
      ...search,
      [changeItem]: changeValue,
    });
  };

  const handleSearch = () => {
    setIsLoading(true);

    const storeId = trim(search.storeId) !== '' ? search.storeId : null;
    const status = search.status !== '' ? search.status : null;

    memberAPI
      .getPayingMemberPlans(page, LIST_PAGE_COUNT, storeId, status)
      .then(
        (rs) => {
          setPlans(rs.payingMemberList);
          setPlanTotal(rs.totalCount);
        },
        (error) => {
          alertError(error);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  const toEditPlan = (id) => {
    history.push(`/MemberManagement/PayingMemberPlan/${id}`);
  };

  const toCreatePlan = () => {
    history.push('/MemberManagement/PayingMemberPlan');
  };

  return (
    <div className="popular pagefadeIn">
      <BreakCrumbs path={match.url}></BreakCrumbs>

      <Box component={Paper} square elevation={2} p={1} mt={3} mb={3}>
        <Grid
          container
          direction="row"
          justify="space-around"
          alignItems="center">
          <Grid item xs>
            <Typography variant="h4" color="textPrimary" gutterBottom>
              VIP 會員方案列表
            </Typography>
          </Grid>

          <Grid item xs style={{ marignLeft: 'auto' }}>
            <div style={{ textAlign: 'right' }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<AddCircleOutlineOutlinedIcon />}
                disabled={isLoading}
                onClick={toCreatePlan}>
                新增方案
              </Button>
            </div>
          </Grid>
        </Grid>

        <Divider light />

        <Box textAlign="right" mt={2} mb={2}>
          <FormControl
            size="small"
            variant="outlined"
            style={{ marginRight: '12px', minWidth: '150px' }}
            disabled={isLoading}>
            <InputLabel>分店篩選</InputLabel>
            <Select
              value={search.storeId}
              name="storeId"
              onChange={handleChangeSearch}
              label="分店篩選">
              <MenuItem value="">全部分店</MenuItem>
              {map(stores, (store) => {
                return (
                  <MenuItem value={store.id} key={store.id}>
                    {store.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <FormControl
            size="small"
            variant="outlined"
            style={{ marginRight: '12px', minWidth: '120px' }}
            disabled={isLoading}>
            <InputLabel>狀態篩選</InputLabel>
            <Select
              value={search.status}
              name="status"
              onChange={handleChangeSearch}
              label="狀態篩選">
              <MenuItem value="">全部狀態</MenuItem>
              {Object.entries(PayingMemberPlanStatusText).map(
                ([value, label]) => (
                  <MenuItem value={Number(value)} key={value}>
                    {label}
                  </MenuItem>
                ),
              )}
            </Select>
          </FormControl>

          <Button
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            disabled={isLoading}
            onClick={() => {
              if (page !== 1) {
                setPage(1);
              } else {
                handleSearch();
              }
            }}>
            搜尋
          </Button>
        </Box>

        {isLoading && <TableLoading />}

        {!isLoading && !plans && <TableEmpty message="無 VIP 會員方案" />}

        {!isLoading && plans && (
          <PayingMemberPlanTable
            plans={plans}
            page={page}
            setPage={setPage}
            total={planTotal}
            toEditPlan={toEditPlan}
          />
        )}
      </Box>
    </div>
  );
};

export default PayingMemberPlanList;
